export enum HalloweenFilter {
  id = '999',
  type = 'halloween',
}

export enum ChristmasFilter {
  id = '998',
  type = 'christmas'
}
